// Private

import { capitalizeWord } from '@/utils/language-service';

// import { pluralize } from '@/utils/language-service';

// Public

const getTriggerTitle = (itemName, serviceName, addOnType) => `${capitalizeWord(addOnType)} add-on in ${serviceName} ${itemName}`;

const TriggerService = {
	getTriggerTitle,
};

export default TriggerService;
